/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResponseClinicDto } from '../../models/response-clinic-dto';

export interface ClinicsControllerFindOne$Params {

/**
 * The tenant of the clinic
 */
  tenant: string;

/**
 * The id of the clinic
 */
  id: string;
}

export function clinicsControllerFindOne(http: HttpClient, rootUrl: string, params: ClinicsControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseClinicDto>> {
  const rb = new RequestBuilder(rootUrl, clinicsControllerFindOne.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseClinicDto>;
    })
  );
}

clinicsControllerFindOne.PATH = '/thalea-clinics/clinics/{tenant}/{id}';
